<template>
  <div class="modal fade" id="editStudentModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Student</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left">
          <form @submit.prevent="updateStudent()" key="name">
            <div class="form-group">
              <label for="name"> Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Name"
                v-model="newStudentName"
                required
              />
            </div>
            <div class="form-group">
              <label for="grade">Grade</label>
              <select
                id="grade"
                name="gradePicker"
                class="form-control selectpicker"
                data-style="btn-outline-primary"
                data-none-selected-text="Select Grade..."
                data-actions-box="true"
                v-model="newStudentGrade"
                required
              >
                <option
                  v-for="grade in Grades.slice().sort($orderByOrder)"
                  :key="grade.Grade_Id + 'grade'"
                  v-bind:value="grade"
                  >{{ grade.Title }}</option
                >
              </select>
            </div>
            <div class="row">
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-danger"
                  v-on:click="cancel"
                >
                  Cancel
                </button>
              </div>
              <div class="col" />
              <div class="col-auto">
                <button type="submit" class="btn btn-primary">
                  UpdateStudent
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "EditStudentModal",
  props: {
    Grades: Array,
    Student: Object
  },
  data() {
    return {
      newStudentName: this.Student.Name,
      newStudentGrade: this.Grades.find(
        g => g.Grade_Id == this.Student.Grade.Grade_Id
      )
    };
  },
  mounted() {
    $("#editStudentModal").on("shown.bs.modal", function() {
      $("#name").focus();
      $(".selectpicker").selectpicker("refresh");
    });
    $(".selectpicker").selectpicker("refresh");
  },
  methods: {
    async updateStudent() {
      $("#editStudentModal").modal("hide");
      this.$store.commit("updateLoading", true);
      var studentToUpdate = {
        Student_Id: this.Student.Student_Id,
        Name: this.newStudentName,
        Image: "",
        Grade: this.newStudentGrade
      };
      await this.$updateStudent(studentToUpdate).then(() => {
        this.$emit("student-edited", studentToUpdate);
        this.$store.commit("updateLoading", false);
      });
    },
    cancel() {
      $("#editStudentModal").modal("hide");
      this.newStudentName = this.Student.Name;
      this.newStudentGrade = this.Grades.find(
        g => g.Grade_Id == this.Student.Grade.Grade_Id
      );
    }
  }
};
</script>
